module.exports = __webpack_public_path__ + "img/feliz.ae3dfb23.png";